export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9668.6d75089a.jpg";